<template>
  <div>
    
    {{ /* TOOLBAR - START */ }}
    <v-app-bar color="primary" class="mainToolbar" app fixed dark >
     
      {{ /* TOOLBAR - BURGER */ }}
      <v-app-bar-nav-icon v-on:click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      {{ /* TOOLBAR - BACK */ }}
      <!--v-toolbar-items v-if="!isEmptyString(backurl)">
        <v-btn icon v-on:click="$root.goToPage(backurl)"><v-icon>keyboard_arrow_left</v-icon></v-btn>
      </v-toolbar-items -->

      <!--v-spacer></v-spacer>
      <v-btn fab small color="grey" bottom left absolute v-on:click="$root.goToPage(backurl)" >
          <v-icon>keyboard_arrow_left</v-icon>
      </v-btn -->

      {{ /* TOOLBAR - TITLE */ }}
      <v-toolbar-title>{{ $t('toolbar.title_closetech')}}</v-toolbar-title>
      
      <v-spacer></v-spacer>
      
      {{ /* TOOLBAR - LOGOUT */ }}
      <!--v-toolbar-items>
				<v-btn icon v-on:click="$root.doLogout()"><v-icon>exit_to_app</v-icon></v-btn>
			</v-toolbar-items-->

     <v-btn class="mr-2" color="secondary" fab small bottom right absolute v-if="!isEmptyString(backurl)"  v-on:click="$root.goToPage(backurl)" >
          <v-icon style="color:#000;" >keyboard_arrow_left</v-icon>
      </v-btn>

      {{ /* TOOLBAR - ESTENSIONE- IDEA ABBANDONATA */ }}
      <!--template v-slot:extension class="mainToolbar_ext" v-if="appname == 'appadmin' || appname == 'appgui' ||  appname == 'appcommerciale'">
        <v-row no-gutters style="background-color: #fff; color: #000;"  >
          <v-col cols="12">
            <span v-if="appname == 'appadmin' ">{{ $t('toolbar.title_appadmin')}}</span>
            <span v-else-if="appname == 'appgui' ">{{ $t('toolbar.title_appgui')}}</span>
            <span v-else-if="appname == 'appcommerciale' ">{{ $t('toolbar.title_appcommerciale')}}</span>
            <span v-else>{{ $t('toolbar.title_closetech')}}</span>
          </v-col>
				</v-row>
      </template--->

    </v-app-bar>
    {{ /* TOOLBAR - END */ }}

    {{ /* DRAWER - START */ }}
    <v-navigation-drawer v-model="drawer" app left temporary>
    
      <!--v-list-item>
        <v-list-item-content >
          <v-list-item-avatar>
              <v-img src="@/assets/img/closetech_avatar.png"></v-img>
          </v-list-item-avatar>
        </v-list-item-content>  
      </v-list-item-->

      {{ /* DRAWER - APP NAME */ }}
      <v-list-item link v-on:click="$root.goToPage('/apps')">
				<v-list-item-content>
          <v-list-item-title class="title">{{ $t('drawer.title') }}</v-list-item-title>

          <v-list-item-subtitle v-if="appname == 'appadmin' ">{{ $t('drawer.subtitle_appadmin')}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else-if="appname == 'appgui' ">{{ $t('drawer.subtitle_appgui')}}</v-list-item-subtitle>
          <v-list-item-subtitle v-else-if="appname == 'appcommerciale' ">{{ $t('drawer.subtitle_appcommerciale')}}</v-list-item-subtitle>
					
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

      <div v-if="!this.isEmptyObj(this.getUser())">

        {{ /* DRAWER - USER */ }}
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{this.findUserAttributesByKey('name')}}</v-list-item-title>
            <v-list-item-subtitle>{{this.getUser().User.Username}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        {{ /* DRAWER - APPS LIST */ }}
        <v-list-item link v-for="item in apps" v-bind:key="item.ID" v-on:click="$root.goToPage('/' + item.app_url)">

            <v-list-item-icon v-if="item.ID == 'a002'">
              <v-icon>visibility</v-icon>
            </v-list-item-icon> 
						<v-list-item-icon v-else-if="item.ID == 'a001'">
              <v-icon>work</v-icon>
             </v-list-item-icon>
						<v-list-item-icon v-else-if="item.ID == 'a003'">
              <v-icon>build</v-icon>
            </v-list-item-icon>
            <v-list-item-icon v-else>
              <v-icon>label</v-icon>
            </v-list-item-icon>
            
            <v-list-item-content>
              <v-list-item-title >
                <span v-if="item.ID == 'a002'">{{ $t('drawer.appgui') }}</span>
                <span v-else-if="item.ID == 'a001'">{{ $t('drawer.appcommerciale') }}</span>
                <span v-else-if="item.ID == 'a003'">{{ $t('drawer.appadmin') }}</span>
                <span v-else>{{ $root.findTranslationInList(item.name)}}</span>
              </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      </div>

      {{ /* DRAWER - LANGUAGE */ }}
      <v-menu offset-x>
        <template v-slot:activator="{ on }">	  	  

          <v-list-item link v-on="on">
            <v-list-item-icon>
              <v-icon>language</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t('drawer.language') }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </template>	
        <v-list>
          <v-list-item @click="$root.changeLocale('en_US')">
            <v-list-tile>ENG</v-list-tile>
          </v-list-item>
          <v-list-item @click="$root.changeLocale('it_IT')">
            <v-list-tile>ITA</v-list-tile>
          </v-list-item>
        </v-list>
      </v-menu>

      {{ /* DRAWER - LOGOUT */ }}
      <v-list-item link  v-if="!this.isEmptyObj(this.getUser())" v-on:click="$root.doLogout()">
				<v-list-item-icon>
					<v-icon>exit_to_app</v-icon>
				</v-list-item-icon>
				<v-list-item-content>
					<v-list-item-title >
						{{ $t('drawer.logout') }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>

		</v-navigation-drawer>
    {{ /* DRAWER - END */ }}

  </div>
</template>
<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
  data: () => ({
    drawer: false,
    apps: [],
  }),
  props: ['appname', 'backurl'],
  mounted() 
	{
    //=== STARTUP
		this.loadUserApps();
	},
  methods: 
    {	
      loadUserApps()
      {
        var userObj = this.getUser();	
        if(!this.isEmptyObj(userObj) && !this.isEmptyObj(userObj.Applications) ){
          this.apps = userObj.Applications;
        }
      },
      findUserAttributesByKey(key)
      {
        if(!this.isEmptyObj(this.getUser()) && !this.isEmptyObj(this.getUser().User) && !this.isEmptyObj(this.getUser().User.UserAttributes))
        {
          for (var i = 0; i < this.getUser().User.UserAttributes.length; i++) 
          {
            var userAttribObj = this.getUser().User.UserAttributes[i];	
            if(userAttribObj.Name== key)
            {
              return userAttribObj.Value;
            }
          }
          return '';
        }
        else 
        {
            return '';
        }
      } 
    }  
};
</script>